<div class="vimeo-player-container">
  @if (loading) {
    <div class="loading">
      <mat-spinner></mat-spinner>
      <p>Chargement de la vidéo...</p>
    </div>
  }

  @if (error && !loading) {
    <div class="error">
      <mat-icon>error_outline</mat-icon>
      <h2>Erreur</h2>
      <p>{{ error }}</p>
    </div>
  }

  @if (vimeoUrl && !loading && !error) {
    <div class="video-wrapper">
      <iframe
        #vimeoIframe
        [src]="vimeoUrl"
        (load)="onIframeLoad()"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        class="vimeo-iframe">
      </iframe>
    </div>
  }
</div>
